import { createSelector } from 'reselect';
import { selectProjectProjection } from '../project/projectProjection.selector';
import { getProjectCasesProjections } from '../../../domain/projection/project/queries/cases/getProjectCasesProjections';
import { ifDefined } from '../../../utils/ifDefined';

export const selectAllCasesProjections = createSelector(
  [selectProjectProjection],
  ifDefined(getProjectCasesProjections)
);
